'use client';
// src/components/shared/SiteFooter.tsx
// Footer partagé — garantit l'accès permanent aux pages légales (LCEN/RGPD).

import Link from '@/components/i18n/Link';
import { useLang, useT } from '@/components/i18n/LangProvider';
import { lienDisponible } from '@/lib/i18n/sections';
import type { Cle } from '@/lib/i18n/t';

// Accès secondaire : pages dé-priorisées dans la navbar plate (Levier 2).
// Elles restent atteignables ici et depuis leurs pages parentes.
const EXPLORE: { label: Cle; href: string }[] = [
  { label: 'pied.actu', href: '/veille' },
  { label: 'pied.graphe', href: '/graphe' },
];

const LINKS: { label: Cle; href: string }[] = [
  { label: 'pied.about', href: '/about' },
  { label: 'pied.methodologie', href: '/methodologie' },
  { label: 'pied.mentions', href: '/mentions-legales' },
  { label: 'pied.confidentialite', href: '/confidentialite' },
  { label: 'pied.corrections', href: '/corrections' },
  { label: 'pied.credits', href: '/credits-photos' },
];

export function SiteFooter() {
  const t = useT();
  const lang = useLang();
  return (
    <footer className="page-footer">
      <div className="page-footer-brand">
        {/* Couverture : le logo typographique de la barre de navigation. */}
        <span style={{ fontFamily: "var(--font-display)", fontSize: 18, fontWeight: 800, letterSpacing: "-0.03em", color: "var(--text-primary)" }}>
          lumière <span style={{ color: "var(--color-uv)" }}>noire</span>
        </span>
      </div>

      <nav
        aria-label={t('pied.explorer')}
        style={{ display: 'flex', gap: 18, flexWrap: 'wrap', alignItems: 'center' }}
      >
        {EXPLORE.filter(({ href }) => lienDisponible(href, lang)).map(({ label, href }) => (
          <Link
            key={href}
            href={href}
            className="page-footer-name"
            style={{ fontWeight: 400, fontSize: 'var(--fs-caption)', textDecoration: 'none' }}
          >
            {t(label)}
          </Link>
        ))}
      </nav>

      <nav
        aria-label={t('pied.liensLegaux')}
        style={{ display: 'flex', gap: 18, flexWrap: 'wrap', alignItems: 'center' }}
      >
        {LINKS.filter(({ href }) => lienDisponible(href, lang)).map(({ label, href }) => (
          <Link
            key={href}
            href={href}
            className="page-footer-name"
            style={{ fontWeight: 400, fontSize: 'var(--fs-caption)', textDecoration: 'none' }}
          >
            {t(label)}
          </Link>
        ))}
      </nav>

      <span className="page-footer-copy">© 2026 Lumière Noire</span>
    </footer>
  );
}
